import MUIGrid from '@/components/MUI-Components/MUI-Grid';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import React, {memo} from 'react';
import dynamic from 'next/dynamic';
import Box from '@mui/material/Box';
import {colors, fontFamily, fontSize, fontWeight} from '@/styles/tokens';
const DisplayImage = dynamic(import('@/components/Ui-components/display-image'));
const headingSx = {
    fontFamily: fontFamily.heading,
    fontWeight: fontWeight.bold,
    fontSize: '55px', // no token match
    color: colors.text.primary,
    paddingTop: '25px',
    lineHeight: '70px',
    '& span': {color: 'RGB(101, 63, 238)'},
    '@media (max-width:430px)': {width: '100%', fontSize: fontSize[30], lineHeight: '45px'}
} as const;

// Migrated from globals.scss `.spotlight-grid` (sole consumer).
const spotlightGridSx = {
    placeSelf: 'center'
} as const;

const FriendspireSpotlight = (props: any) => {
    const {heading, clientdescription, image, image2, clientname, className, productname, productimg} = props;
    return (
        <Box>
            <MUITypography className={`${className} center`} sx={headingSx}>
                {heading}
            </MUITypography>
            <Box className="divder-wrapper">
                <hr className="divider-line" />
            </Box>
            <MUIGrid container>
                <MUIGrid item xs={12} sm={12} md={6} lg={6}>
                    <MUITypography className="client-description"> {clientdescription}</MUITypography>
                </MUIGrid>
                <MUIGrid item xs={12} sm={12} md={6} lg={6} className="spotlight-grid" sx={spotlightGridSx}>
                    <Box className="spotlight-client-section" sx={{textAlign: 'center'}}>
                        <Box className="client-img-wrapper" sx={{display: 'flex', justifyContent: 'center', gap: '30px', flexWrap: 'wrap'}}>
                            <DisplayImage src={image2} alt="client1" />
                            <DisplayImage src={image} alt="client" />
                        </Box>
                        <Box className="top-spacing">
                            <MUITypography className="client-name">{clientname}</MUITypography>
                            <MUITypography className="client-intro">{productname}</MUITypography>
                            <DisplayImage src={productimg} alt="clientproduct" />
                        </Box>
                    </Box>
                </MUIGrid>
            </MUIGrid>
        </Box>
    );
};
export default memo(FriendspireSpotlight);
